<template>
	<app-page>
		<div class="main-title">
			国家税务总局关于研发费用税前加计扣除归集范围有关问题的公告
		</div>
		<div class="flex flex-end clearfix">
			<el-button type="primary" @click="goback()">返回</el-button>
		</div>
		<div class="detail-content">
			<div data-v-bbdef3ee="" class="detail-content">
				<p style="text-align:center;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#999999"
									>国家税务总局公告2017年第40号</span
								></span
							></span
						></span
					>
				</p>
				<p style="text-align:center;"></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									为进一步做好研发费用税前加计扣除优惠政策的贯彻落实工作，切实解决政策落实过程中存在的问题，根据《财政部
									国家税务总局
									科技部关于完善研究开发费用税前加计扣除政策的通知》（财税〔2015〕119号）及《国家税务总局关于企业研究开发费用税前加计扣除政策有关问题的公告》（国家税务总局公告2015年第97号）等文件的规定，现就研发费用税前加计扣除归集范围有关问题公告如下：</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 一、人员人工费用</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									指直接从事研发活动人员的工资薪金、基本养老保险费、基本医疗保险费、失业保险费、工伤保险费、生育保险费和住房公积金，以及外聘研发人员的劳务费用。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）直接从事研发活动人员包括研究人员、技术人员、辅助人员。研究人员是指主要从事研究开发项目的专业人员；技术人员是指具有工程技术、自然科学和生命科学中一个或一个以上领域的技术知识和经验，在研究人员指导下参与研发工作的人员；辅助人员是指参与研究开发活动的技工。外聘研发人员是指与本企业或劳务派遣企业签订劳务用工协议（合同）和临时聘用的研究人员、技术人员、辅助人员。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									接受劳务派遣的企业按照协议（合同）约定支付给劳务派遣企业，且由劳务派遣企业实际支付给外聘研发人员的工资薪金等费用，属于外聘研发人员的劳务费用。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）工资薪金包括按规定可以在税前扣除的对研发人员股权激励的支出。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）直接从事研发活动的人员、外聘研发人员同时从事非研发活动的，企业应对其人员活动情况做必要记录，并将其实际发生的相关费用按实际工时占比等合理方法在研发费用和生产经营费用间分配，未分配的不得加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 二、直接投入费用</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									指研发活动直接消耗的材料、燃料和动力费用；用于中间试验和产品试制的模具、工艺装备开发及制造费，不构成固定资产的样品、样机及一般测试手段购置费，试制产品的检验费；用于研发活动的仪器、设备的运行维护、调整、检验、维修等费用，以及通过经营租赁方式租入的用于研发活动的仪器、设备租赁费。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）以经营租赁方式租入的用于研发活动的仪器、设备，同时用于非研发活动的，企业应对其仪器设备使用情况做必要记录，并将其实际发生的租赁费按实际工时占比等合理方法在研发费用和生产经营费用间分配，未分配的不得加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）企业研发活动直接形成产品或作为组成部分形成的产品对外销售的，研发费用中对应的材料费用不得加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									产品销售与对应的材料费用发生在不同纳税年度且材料费用已计入研发费用的，可在销售当年以对应的材料费用发生额直接冲减当年的研发费用，不足冲减的，结转以后年度继续冲减。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 三、折旧费用</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									指用于研发活动的仪器、设备的折旧费。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）用于研发活动的仪器、设备，同时用于非研发活动的，企业应对其仪器设备使用情况做必要记录，并将其实际发生的折旧费按实际工时占比等合理方法在研发费用和生产经营费用间分配，未分配的不得加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）企业用于研发活动的仪器、设备，符合税法规定且选择加速折旧优惠政策的，在享受研发费用税前加计扣除政策时，就税前扣除的折旧部分计算加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 四、无形资产摊销费用</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									指用于研发活动的软件、专利权、非专利技术（包括许可证、专有技术、设计和计算方法等）的摊销费用。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）用于研发活动的无形资产，同时用于非研发活动的，企业应对其无形资产使用情况做必要记录，并将其实际发生的摊销费按实际工时占比等合理方法在研发费用和生产经营费用间分配，未分配的不得加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）用于研发活动的无形资产，符合税法规定且选择缩短摊销年限的，在享受研发费用税前加计扣除政策时，就税前扣除的摊销部分计算加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									五、新产品设计费、新工艺规程制定费、新药研制的临床试验费、勘探开发技术的现场试验费</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									指企业在新产品设计、新工艺规程制定、新药研制的临床试验、勘探开发技术的现场试验过程中发生的与开展该项活动有关的各类费用。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 六、其他相关费用</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									指与研发活动直接相关的其他费用，如技术图书资料费、资料翻译费、专家咨询费、高新科技研发保险费，研发成果的检索、分析、评议、论证、鉴定、评审、评估、验收费用，知识产权的申请费、注册费、代理费，差旅费、会议费，职工福利费、补充养老保险费、补充医疗保险费。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									此类费用总额不得超过可加计扣除研发费用总额的10%。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 七、其他事项</span></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）企业取得的政府补助，会计处理时采用直接冲减研发费用方法且税务处理时未将其确认为应税收入的，应按冲减后的余额计算加计扣除金额。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）企业取得研发过程中形成的下脚料、残次品、中间试制品等特殊收入，在计算确认收入当年的加计扣除研发费用时，应从已归集研发费用中扣减该特殊收入，不足扣减的，加计扣除研发费用按零计算。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（三）企业开展研发活动中实际发生的研发费用形成无形资产的，其资本化的时点与会计处理保持一致。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（四）失败的研发活动所发生的研发费用可享受税前加计扣除政策。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（五）国家税务总局公告2015年第97号第三条所称“研发活动发生费用”是指委托方实际支付给受托方的费用。无论委托方是否享受研发费用税前加计扣除政策，受托方均不得加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									委托方委托关联方开展研发活动的，受托方需向委托方提供研发过程中实际发生的研发项目费用支出明细情况。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									八、执行时间和适用对象</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									本公告适用于2017年度及以后年度汇算清缴。以前年度已经进行税务处理的不再调整。涉及追溯享受优惠政策情形的，按照本公告的规定执行。科技型中小企业研发费用加计扣除事项按照本公告执行。</span
								></span
							></span
						></span
					>
				</p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									国家税务总局公告2015年第97号第一条、第二条第（一）项、第二条第（二）项、第二条第（四）项同时废止。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p></p>
				<p style="text-align:right;"></p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">国家税务总局</span></span
							></span
						></span
					>
				</p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">2017年11月8日</span></span
							></span
						></span
					>
				</p>
			</div>
		</div>
	</app-page>
</template>
<script>
import AppPage from "@/components/semantics/AppPage.vue";

export default {
	components: {
		AppPage
	},
	methods: {
		goback() {
			this.$router.go(-1);
		}
	}
};
</script>